<template>
  <div>
    <h1>Profile view</h1>

    <!-- Action buttons -->
    <!-- <v-btn id="downloadGoals" :href="this.getGoalsLink" download>Download Goals overview</v-btn>
    <v-btn id="downloadFilters" :href="this.getFiltersLink" download>Download Filters overview</v-btn>-->
  </div>
</template>

<script>
import store from "@/store.js";

export default {
  name: "Profile-View",
  props: ["accountId", "propertyId", "profileId"],
  mounted() {
    this.$store.dispatch("setNavigation", {
      account: this.accountId,
      webProperty: this.propertyId,
      profile: this.profileId
    });
  },
  computed: {
    Management() {
      return this.$store.state.Management;
    },
    loggedIn() {
      return this.$store.state.loggedIn;
    },
    authParams() {
      return this.$store.state.auth.params;
    },
    getFiltersLink() {
      if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/accounts/${
          this.accountId
        }/webproperties/${this.propertyId}/profiles/${this.profileId}/filters${
          this.authParams
        }`;
      } else {
        return `/api/accounts/${this.accountId}/webproperties/${
          this.propertyId
        }/profiles/${this.profileId}/filters${this.authParams}`;
      }
    },
    getGoalsLink() {
      if (process.env.NODE_ENV === "development") {
        return `/accounts/${this.accountId}/webproperties/${
          this.propertyId
        }/profiles/${this.profileId}/filters${this.authParams}`;
      } else {
        return `/api/accounts/${this.accountId}/webproperties/${
          this.propertyId
        }/profiles/${this.profileId}/filters${this.authParams}`;
      }
    }
  }
};
</script>


<style scoped>
tr {
  cursor: pointer;
}
</style>
